import { Workbox } from "workbox-window";

const createWorkbox = () => {
  if ("serviceWorker" in navigator && import.meta.env.VITE_APP_SOCIO_GRPC_API_ENV !== "local") {
    const wb = new Workbox(`${import.meta.env.BASE_URL}service-worker.js`);

    wb.addEventListener("waiting", () => {
      window.dispatchEvent(new Event("newAppIsAvailable"));
    });

    wb.addEventListener("controlling", () => {
      window.location.reload();
    });

    wb.register();

    return wb;
  }

  return null;
};

const wb = createWorkbox();
export default wb;
